<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div
            class="page-title-content"
           
        >
            <h2  data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="1200">Retail</h2>
            <ul  data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="1200">
                <li><a routerLink="/">Home</a></li>
                <li>Retail</li>
            </ul>
        </div>
    </div>
     
</div>
<!-- End Page Title Area -->

<!-- Start Retails Area -->


<!-- <div class="aboutus-hb__control_panel">
    <div class="aboutus-hb__yearline">
        <div class="aboutus-hb__yearline_track">
            <div
            class="page-heading"
            style="
                height: 150px;
                text-align: center;
                color: #000000;
                margin-bottom: 40px;
                text-transform: uppercase;
            "
        >
            <h1>
                <b
                    >Vocbot  Innovates Retail Solutions for Complex Challenges</b
                >
            </h1>
             
        </div>
        </div>
    </div>
     
</div> -->

<section class="team-area ">
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <!-- <div class="col-lg-12 col-md-12 col-sm-12">
                   
                </div> -->
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/retail-customer.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3
                            style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            "
                        >
                        Customer Engagement
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p
                            style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            "
                        >
                        Vocbot ensures customer engagement through various channels with real-time interactive conversations.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3
                            style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            "
                        >
                        Product Recommendations
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p
                            style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            "
                        >Vocbot analyses customer preferences based on their purchase history and provides product recommendations.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/retail-product.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                 
                   
                
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/retail-order.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3
                            style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            "
                        >
                        Order Assistance
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p
                            style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            "
                        >
                        Vocbot provides real-time updates about order status, shipping details, and delivery time and addresses order-related queries.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3
                            style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            "
                        >
                        Inventory Information
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p
                            style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            "
                        >
                        Users can check product availability, sizes, and colors with the help of Vocbot which can retrieve information from the inventory database for accurate responses.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/retail-inventory.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
               
                   
              
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/retail-promotional.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3
                            style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            "
                        >
                        Promotional Campaigns
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p
                            style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            "
                        >
                        Vocbot can inform customers about ongoing promotions, discounts, and special offers and also guide them on how to avail of them.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area-2 pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3
                            style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            "
                        >
                        Customer Support
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p
                            style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            "
                        >
                        Vocbot provides instant support in multiple languages and resolves customers’ concerns efficiently.
                        </p>
                    </div>
                </div>
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/customer-support.png" alt="image" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ai-solution-area pb-100 common-height-container">
        <div class="container-fluid">
            <div class="row justify-content-center align-items-center">
               
                <div class="media col-lg-5 col-md-6 col-sm-12">
                    <div class="ai-solution-wrap-image">
                        <img src="assets/img/retail-feedback.png" alt="image" />
                    </div>
                </div>

                <div class="text col-lg-5 col-md-6 col-sm-12 ml-3">
                    <div class="ai-solution-content">
                        <h3
                            style="
                                font-size: 44.8px ;
                                line-height: 59px ;
                                margin-bottom: 0px ;
                            "
                        >
                        Feedback and Surveys
                        </h3>
                        <img src="assets/img/RO.gif" style="height: 30px" />
                        <p
                            style="
                                font-size: 21px ;
                                line-height: 38px ;
                                margin-top: 50px;
                                margin-bottom: 35px ;
                            "
                        >
                        Vocbot collects customer feedback after purchases and conducts surveys to gather useful insights on customer satisfaction.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

   
</section>
<!-- <section class="team-area ptb-110">
<div
    class="page-heading"
    data-aos="fade-down"
    data-aos-easing="linear"
    data-aos-duration="1200"
    style="
        height: 150px;
        text-align: center;
        color: #000000;
        margin-bottom: 40px;
        text-transform: uppercase;
    "
>
    <h1>
        <b>Vocbot  Innovates Retail Solutions for Complex Challenges</b>
    </h1>
    <img src="assets/img/RO.gif" style="height: 35px" />
</div>




<div class="container-fluid"  >
    <div class="row">

        <div class="row member-content">
            <div class="col-lg-12 col-md-12">

              
                <div class="row row-margin-1" data-aos="zoom-in">
                    <div class="col-sm-12 col-md-4  col-lg-4 member-thumb-1 ">
                        <img src="assets/img/retail-customer.png" class="rounded-circle" alt="">
                       
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-8 mobile-content">
                        <div class="details-1" data-aos="fade-right"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine">
                        
                            <p class="title mb-2">Customer Engagement</p>
                            
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2">Chatbots initiate conversations with customers through
                                various channels.They can greet users, offer assistance, and
                                engage in interactive dialogues.</p>
                        </div>
                    </div>
                </div>

          

    
                <div class="row row-margin-2 mobile-margin-top" data-aos="zoom-in">
                    
                    <div class="col-sm-12 col-lg-8 order-lg-1 order-sm-2 order-xs-2 order-2 mobile-content">
                        <div class="details-2" data-aos="fade-left"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine " >
                            <p class="title mb-2">Product Recommendations</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2"> Vocbot  analyze customer preferences and buying history. They
                                provide personalized product recommendations based on user
                                profiles.</p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-4 member-thumb-2 order-lg-2  order-sm-1 order-xs-1 order-1 ">
                        <img src="assets/img/retail-product.png" class="rounded-circle" alt="">
                       
                    </div>
                </div>


              
                <div class="row row-margin-1  mobile-margin-top" data-aos="zoom-in">
                    <div class="col-sm-12 col-lg-4 member-thumb-1  ">
                        <img src="assets/img/retail-order.png" class="rounded-circle" alt="">
                       
                    </div>
                    <div class="col-sm-12 col-lg-8  mobile-content">
                        <div class="details-1" data-aos="fade-right"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine">
                            <p class="title mb-2">Order Assistance</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2"> Customers can inquire about order status, shipping details,
                                and delivery times. Chatbots offer real-time updates and
                                address order-related queries.</p>
                        </div>
                    </div>
                </div>

 

    
                <div class="row row-margin-2 mobile-margin-top" data-aos="zoom-in">
                    
                    <div class="col-sm-12 col-lg-8 order-lg-1 order-lg-2  order-sm-2 order-xs-2 order-2 mobile-content ">
                        <div class="details-2" data-aos="fade-left"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine " >
                            <p class="title mb-2">Inventory Information</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2">Users can check product availability, sizes, and colors
                                through chatbots. Vocbot  retrieve information from the
                                inventory database for accurate responses.</p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-4 member-thumb-2 order-lg-2 order-lg-1 order-sm-1 order-xs-1 order-1 ">
                        <img  src="assets/img/retail-inventory.png" class="rounded-circle" alt="">
                       
                    </div>
                </div>


                 
                <div class="row row-margin-1 mobile-margin-top" data-aos="zoom-in">
                    <div class="col-sm-12 col-lg-4 member-thumb-1 order-lg-2 order-lg-1 order-sm-1 order-xs-1 order-1  ">
                        <img src="assets/img/retail-promotional.png" class="rounded-circle" alt="">
                       
                    </div>
                    <div class="col-sm-12 col-lg-8 order-lg-1 order-lg-2  order-sm-2 order-xs-2 order-2 mobile-content">
                        <div class="details-1" data-aos="fade-right"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine">
                            <p class="title mb-2">Promotional Campaigns</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2"> Vocbot  can inform customers about ongoing promotions,
                                discounts, and special offers. They may guide users on how
                                to avail of these promotions.</p>
                        </div>
                    </div>
                </div>

          

    
                <div class="row row-margin-2 mobile-margin-top " data-aos="zoom-in">
                    
                    <div class="col-sm-12 col-lg-8 order-lg-1 order-sm-2 order-xs-2 order-2 mobile-content">
                        <div class="details-2" data-aos="fade-left"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine " >
                            <p class="title mb-2">Customer Support</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2">Vocbot  handle common customer queries and issues. They
                                provide instant support, resolving concerns efficiently.</p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-4 member-thumb-2 order-lg-2 order-lg-1 order-sm-1 order-xs-1 order-1 function-image  ">
                        <img src="assets/img/retail-support.png" class="rounded-circle" alt="">
                       
                    </div>
                </div>

                <div class="row row-margin-1 mobile-margin-top" data-aos="zoom-in">
                    <div class="col-sm-12 col-lg-4 member-thumb-1 order-lg-1 order-sm-1 order-xs-1 order-1  function-image">
                        <img src="assets/img/retail-feedback.png" class="rounded-circle" alt="">
                       
                    </div>
                    <div class="col-sm-12 col-lg-8 order-sm-2 order-xs-2 order-2 mobile-content">
                        <div class="details-1" data-aos="fade-right"
                        data-aos-offset="500"
                        data-aos-easing="ease-in-sine">
                            <p class="title mb-2">Feedback and Surveys</p>
                            <img src="assets/img/RO.gif" style="height: 35px" />
                            <p class="mt-2"> Vocbot  collect customer feedback after purchases. They may
                                conduct surveys to gather insights on customer satisfaction.</p>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    
    </div>
</div>
</section> -->
